/* eslint-disable react/style-prop-object */
import React, { useState } from "react";
import Empty from "../../../Helpers/Empty/Empty";
import TableRow from "../../../Helpers/Table/TableRow";
import TableChildren from "../../../Helpers/Table/TableChildren";
import CustomTag from "../../../Helpers/Tag/Tag";
import TableActions from "../../../Helpers/Table/TableActions2";
import RegularDelete from "../RegularPopup/RegularDelete";
import RequestPopup from "../PopupBody/RegularPopup";
import RegularPopup from "../RegularPopup/RegularPopup";

export default function RegularTableBody({ data }) {
  const [showId, setShowId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [editId, setEditId] = useState("");
  const getTagColor = (priority) => {
    switch (priority) {
      case "Highest":
        return "red";
      case "High":
        return "magenta";
      case "Medium":
        return "green";
      case "Low":
        return "geekblue";
      default:
        return "purple"; // Fallback color
    }
  };
  const onClose = () => {
    setDeleteId("");
    setShowId("");
    setEditId("");
  };
  return (
    <>
      {data?.length > 0 ? (
        data.map((i) => {
          const tagColor = getTagColor(i.priority); // Determine tag color for each row
          return (
            <div key={i.id} className="table-row">
              <TableRow value={i.code} />
              <TableRow value={i.name} />
              <TableChildren>
                <CustomTag text={i.priority} color={tagColor} />
              </TableChildren>
              <TableRow value={i.intervals} />
              <TableRow value={i.description} valuestyle={"truncate-2-lines"} />
              <TableActions
                setShowId={setShowId}
                setDeleteId={setDeleteId}
                setEditId={setEditId}
                data={i}
                button1="Add"
                button2="Eye"
                button3="Delete"
              />
            </div>
          );
        })
      ) : (
        <Empty
          title="No Regular Maintenance found"
          subtitle="Create your first regular maintenance now!"
        />
      )}
      {!!deleteId && (
        <RegularDelete
          id={deleteId.id}
          deleteType={deleteId.name}
          onClose={onClose}
        />
      )}
      {!!showId && (
        <RequestPopup id={showId.id} onClose={onClose} title={showId.name} />
      )}
      {!!editId && (
        <RegularPopup id={editId.id} onClose={onClose} title={editId.name} />
      )}
    </>
  );
}
